import { render, staticRenderFns } from "./OnHoldItems.vue?vue&type=template&id=6992ffe2&scoped=true"
import script from "./OnHoldItems.vue?vue&type=script&lang=js"
export * from "./OnHoldItems.vue?vue&type=script&lang=js"
import style0 from "./OnHoldItems.vue?vue&type=style&index=0&id=6992ffe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6992ffe2",
  null
  
)

export default component.exports